<template>
  <Modal v-model="visible" title="计划智能检测" class-name="vertical-center-modal" :width="920" :mask-closable="false">
    <Spin size="large" fix v-if="loading" />
    <div class="c-success-warpper">
      <div class="c-success-header"><h3>检测结果</h3></div>
      <Table height="400" :columns="tableColumn" :data="tableData"> </Table>
    </div>

    <div slot="footer" class="c-convert-footer">
      <Button @click="$emit('input', false)">返回修改</Button>
      <Button @click="$emit('submit')">创建全部</Button>
      <Button type="primary" :disabled="disadvice" @click="$emit('advice')">去掉不推荐提交</Button>
    </div>
  </Modal>
</template>
<script>
const tableColumn = [
  {
    key: 'planId',
    title: '序号',
    width: 60,
    align: 'center',
    render: (h, params) => {
      return h('span', params.row.planId + 1)
    }
  },
  {
    key: 'planName',
    title: '计划名称'
  },
  {
    key: 'images',
    title: '素材使用情况',
    width: 260,
    render: (h, params) => {
      const child = params.row.images.map((ret) => {
        return h('li', [h('span', ret.imageName), h('span', ret.planCount ? `计划数：${ret.planCount}` : '')])
      })
      return h('ul', child)
    }
  },
  {
    key: 'msg',
    title: '创建建议',
    tooltip: true
  }
]

export default {
  name: 'result-image',
  props: {
    value: {
      type: Boolean
    },
    tableData: {
      type: Array
    },
    loading: {
      type: Boolean
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    disadvice() {
      return this.tableData.every((ret) => !ret.advice)
    }
  },
  data() {
    return {
      tableColumn: tableColumn
    }
  }
}
</script>
<style lang="scss" scoped>
.c-success-warpper {
  padding: 0 20px 12px 20px;

  .c-success-header {
    text-align: center;
    padding: 12px 0;

    h3 {
      font-weight: 600;
    }
  }
}
</style>
